import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { SaveCampaignDialog } from '@ooh/ui/components/save-campaign-dialog';
import type { Poi } from '@ooh/contracts';
import { useSoftDeletePoi } from '../api/mutations';
import type { WithCallWithAuth } from '../api/queries';

interface DeletePoiDialogProps {
  poi: Poi | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  auth?: WithCallWithAuth;
}

export function DeletePoiDialog({ poi, open, onOpenChange, auth }: DeletePoiDialogProps) {
  const { t } = useTranslation('map');
  const { mutateAsync, isPending } = useSoftDeletePoi(auth);

  if (!open || !poi) return null;

  const handleConfirm = () => {
    if (isPending) return;
    void mutateAsync({ id: poi.id })
      .then(() => {
        toast.success(t('admin.pois.toast.deleteSuccess'));
        onOpenChange(false);
      })
      .catch(() => {
        toast.error(t('admin.pois.toast.deleteError'));
      });
  };

  return (
    <SaveCampaignDialog
      title={t('admin.pois.deleteDialog.title')}
      description={t('admin.pois.deleteConfirm', { name: poi.name })}
      cancelLabel={t('admin.pois.deleteDialog.cancel')}
      saveLabel={t('admin.pois.deleteDialog.confirm')}
      onClose={() => onOpenChange(false)}
      onSave={handleConfirm}
    />
  );
}
